import {Fancybox} from "@fancyapps/ui";

const fancyPopups = () => {
    Fancybox.bind("[data-fancybox]", {
        Html: {
            video: {
                autoplay: true,
                muted: false,
                loop: false,
            },
        },
    });
}


export default fancyPopups;


// WEBPACK FOOTER //
// ./scripts/modules/fancyPopups.js